'use strict';

var isSymbol = require('./is-symbol');

module.exports = function (value) {
	if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
	return value;
};



//////////////////
// WEBPACK FOOTER
// ./~/es6-symbol/validate-symbol.js
// module id = 725
// module chunks = 0